import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, loading } = useAuth();
  
  // Still loading - show nothing (AuthProvider handles this)
  if (loading) {
    return null;
  }
  
  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Check role-based access if required
  if (requiredRole) {
    if (requiredRole === 'admin' && user.userType !== 'admin') {
      return <Navigate to="/" replace />;
    }
    if (requiredRole === 'employee' && user.userType !== 'employee') {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }
  
  return children;
};

export default ProtectedRoute;
